// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1015W","info":"PatientInfo_info__2M56e"};